import script from "./MacroAnalysisHistgram.vue?vue&type=script&lang=ts&setup=true"
export * from "./MacroAnalysisHistgram.vue?vue&type=script&lang=ts&setup=true"

import "./MacroAnalysisHistgram.vue?vue&type=style&index=0&id=5b9abdd4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b9abdd4"]])

export default __exports__